module.exports = __webpack_public_path__ + "assets/86927d87e27fafe3083cb4b387e6fc8b.png";